// Only type change needed
import React from "react";
import MiniCard from "./Minicard/MiniCard";
import { StoreCardGroup } from "../../lib/types/detailsTypes";
import { Box, CircularProgress } from "@mui/material";

interface MainCardsDisplayProps {
  cards: StoreCardGroup[]; // Changed to groups
  loading: boolean;
}

const MainCardsDisplay: React.FC<MainCardsDisplayProps> = ({
  cards,
  loading,
}) => {
  return (
    <Box
      display="flex"
      flexWrap="wrap"
      gap={1.5}
      justifyContent="center"
      width={"100%"}
    >
      {loading ? (
        <CircularProgress />
      ) : (
        cards.map((group) => (
          <MiniCard key={`${group.storeID}-${group.city}`} group={group} />
        ))
      )}
    </Box>
  );
};

export default MainCardsDisplay;
